module.exports = __webpack_public_path__ + "img/journal-album.548bdfde.svg";